import { MediaUploadComponent } from "components/ui-elements";
import { getIn, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FileUploadActions from "redux-container/file-upload-S3/fileUploadRedux";
import { IInitinalValueProjectContent } from "../InitinalValuesProjectContent";

const actionDispatch = (dispatch: any) => {
  return {
    setUploadFileState: (key: any, data: any) => {
      dispatch(FileUploadActions.setUploadFileState(key, data));
    },
    fileUploadRequest: (data: any) => {
      dispatch(FileUploadActions.fileUploadRequest(data));
    },
    fileDeleteRequest: (data: any) => {
      dispatch(FileUploadActions.fileDeleteRequest(data));
    },
  };
};
function ImageUploaderForGeneralInfo() {
  const { values, setFieldValue, errors, touched } =
    useFormikContext<IInitinalValueProjectContent>();

  const { imageDetails, isLoading } = useSelector(
    (state: any) => state.fileUpload
  );

  const { setUploadFileState, fileUploadRequest, fileDeleteRequest } =
    actionDispatch(useDispatch());

  const [componentName, setComponentName] = useState<any>(null);
  const [shouldMediaUpload, setShouldMediaUpload] = useState(false);
  const isViewMode = useSelector(
    (state: any) => state?.projectContentManagement?.isViewMode
  );
  const handleImageUpload = (event: any) => {
    const file = event.target.files[0];
    setShouldMediaUpload(true);
    if (file) {
      const data = {
        name: file?.name,
        file,
        urlType: "upload",
        binary: "",
      };
      const reader = new FileReader();
      reader.onload = (event: any) => {
        data.binary = event.target.result;
        fileUploadRequest(data);
      };
      reader.readAsArrayBuffer(file);

      setFieldValue(`address.mapMedia.key`, file?.name);
      setFieldValue(`address.mapMedia.name`, file?.name);
      setFieldValue(`address.mapMedia.value.size`, file?.size);
      setFieldValue(`address.mapMedia.value.type`, file?.type);
    }
  };

  const cancelImageHandler = () => {
    fileDeleteRequest(values?.address?.mapMedia?.name);

    setFieldValue(`address.mapMedia.value.url`, "");
    setFieldValue(`address.mapMedia.value.size`, "");
    setFieldValue(`address.mapMedia.name`, "");
    setFieldValue(`address.mapMedia.key`, "");
  };

  const onChangeHandler = (event: any) => {
    handleImageUpload(event);
  };
  useEffect(() => {
    if (imageDetails && shouldMediaUpload) {
      const imageRes = imageDetails;
      setUploadFileState("imageDetails", null);
      if (componentName === "ImageUploaderForGeneralInfo") {
        const mapMedia = { ...values.address?.mapMedia };

        mapMedia.value.url = imageRes?.url;

        setFieldValue(`address.mapMedia`, mapMedia);
      }
      setShouldMediaUpload(false);
    }
  }, [imageDetails]);
  return (
    <>
      <MediaUploadComponent
        name="ImageUploaderForGeneralInfo"
        onChange={(event: any) => {
          onChangeHandler(event);
          setComponentName(event.target.name);
        }}
        cancelimage={cancelImageHandler}
        previewimage={values?.address?.mapMedia?.value?.url}
        loading={isLoading}
        fieldhelpertext={
          getIn(touched, `address.mapMedia.value.url`) &&
          getIn(errors, `address.mapMedia.value.url`)
        }
        disabled={isViewMode}
      />
    </>
  );
}

export default ImageUploaderForGeneralInfo;
